import type { Location } from 'react-router-dom'

const isActiveLink = (location: Location, url: string, workspace?: string) => {
  // Show 'dashboard' link as active if it matches the the '/' exactly
  if (url === `/c/${workspace}`) {
    return location.pathname === url || location.pathname === `${url}/`
  }

  // Otherwise - show 'Assemblies' link as active, both if we hit '/assemblies' and '/assemblies/:id'
  return location.pathname.startsWith(url)
}

export default isActiveLink
